import { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import LegalFooter from "../components/LegalFooter";

export default function ResetPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const token = new URLSearchParams(location.search).get("token") || "";

  const submit = async (e) => {
    e.preventDefault(); setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/login"), 1200);
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <h1 className="mb-1">Set new password</h1>
        <p className="text-[12px] mb-6" style={{ color: "var(--parapet-text-secondary)" }}>Token: <span className="value-mono">{token?.slice(0, 12)}…</span></p>
        {done ? (
          <p className="text-[13px]">Password updated. Redirecting to sign-in…</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input type="password" className="p-input" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={8} placeholder="New password" data-testid="reset-pw-input" />
            {error && <div className="text-[12px]">{error}</div>}
            <button type="submit" className="btn-primary w-full" data-testid="reset-submit-button">Set password</button>
          </form>
        )}
        <p className="text-[12px] mt-4 text-center"><Link to="/login" className="underline">Back to sign in</Link></p>
      </div>
      <LegalFooter variant="fixed" />
    </div>
  );
}
